"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlAccountCreator = exports.LocalAccountCreator = exports.AccountCreator = void 0;
var accounts_1 = require("@near-js/accounts");
Object.defineProperty(exports, "AccountCreator", { enumerable: true, get: function () { return accounts_1.AccountCreator; } });
Object.defineProperty(exports, "LocalAccountCreator", { enumerable: true, get: function () { return accounts_1.LocalAccountCreator; } });
Object.defineProperty(exports, "UrlAccountCreator", { enumerable: true, get: function () { return accounts_1.UrlAccountCreator; } });
